import React from 'react';
import { Link } from 'react-router-dom';

const DashboardHeader = () => {
  return (
    <header className="bg-black text-white p-4">
      <div className="container mx-auto flex items-center justify-between">
        <Link 
          to="/" 
          className="hover:opacity-80 transition-opacity duration-300 flex items-center"
        >
          <h1 className="text-2xl font-bold cursor-pointer">
            Our Energy Futures: Your Choices Matter
          </h1>
        </Link>
        <p className="text-sm mt-1 hidden md:block">
          Exploring how our collective decisions shape the path to Net Zero
        </p>
      </div>
    </header>
  );
};

export default DashboardHeader; 